"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeDeploymentsL1ChainIds = exports.safeDeploymentsVersions = exports.SAFE_BASE_VERSION = exports.DEFAULT_SAFE_VERSION = void 0;
exports.DEFAULT_SAFE_VERSION = '1.3.0';
exports.SAFE_BASE_VERSION = '1.0.0';
exports.safeDeploymentsVersions = {
    '1.4.1': {
        safeSingletonVersion: '1.4.1',
        safeSingletonL2Version: '1.4.1',
        safeProxyFactoryVersion: '1.4.1',
        compatibilityFallbackHandler: '1.4.1',
        multiSendVersion: '1.4.1',
        multiSendCallOnlyVersion: '1.4.1',
        signMessageLibVersion: '1.4.1',
        createCallVersion: '1.4.1'
    },
    '1.3.0': {
        safeSingletonVersion: '1.3.0',
        safeSingletonL2Version: '1.3.0',
        safeProxyFactoryVersion: '1.3.0',
        compatibilityFallbackHandler: '1.3.0',
        multiSendVersion: '1.3.0',
        multiSendCallOnlyVersion: '1.3.0',
        signMessageLibVersion: '1.3.0',
        createCallVersion: '1.3.0'
    },
    '1.2.0': {
        safeSingletonVersion: '1.2.0',
        safeSingletonL2Version: undefined,
        safeProxyFactoryVersion: '1.1.1',
        compatibilityFallbackHandler: '1.3.0',
        multiSendVersion: '1.1.1',
        multiSendCallOnlyVersion: '1.3.0',
        signMessageLibVersion: '1.3.0',
        createCallVersion: '1.3.0'
    },
    '1.1.1': {
        safeSingletonVersion: '1.1.1',
        safeSingletonL2Version: undefined,
        safeProxyFactoryVersion: '1.1.1',
        compatibilityFallbackHandler: '1.3.0',
        multiSendVersion: '1.1.1',
        multiSendCallOnlyVersion: '1.3.0',
        signMessageLibVersion: '1.3.0',
        createCallVersion: '1.3.0'
    },
    '1.0.0': {
        safeSingletonVersion: '1.0.0',
        safeSingletonL2Version: undefined,
        safeProxyFactoryVersion: '1.0.0',
        compatibilityFallbackHandler: '1.3.0',
        multiSendVersion: '1.1.1',
        multiSendCallOnlyVersion: '1.3.0',
        signMessageLibVersion: '1.3.0',
        createCallVersion: '1.3.0'
    }
};
exports.safeDeploymentsL1ChainIds = [
    1n // Ethereum Mainnet
];
